import { createContext, type PropsWithChildren } from 'react'

type Partner = {
  image: {
    desktop: string
    mobile: string
  }
  name: string
  link: string
  discount: number
}

export type DebtsPartnersProps = PropsWithChildren<{
  list: Partner[]
}>

export const DebtsPartnersContext = createContext<DebtsPartnersProps>({
  list: [],
})

export const DebtsPartnersProvider = ({ list, ...props }: DebtsPartnersProps) => (
  <DebtsPartnersContext.Provider value={{ list }} {...props} />
)
